const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      '& > *': {
        opacity: 0,
      },
    },
    cols: {
      flexWrap: 'wrap',
      '& > *': {
        width: (props) => `calc((100% - ${props.cols > 1 ? 10 * props.cols : 0}px) / ${props.cols})`,
        // width: (props) => (props.cols === 1 ? '100%' : 'auto'),
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      flexDirection: 'column',
      '& > *:not(:last-child)': {
        marginBottom: 25,
      },
    },
    cols: {
      marginLeft: 0,
      marginRight: 0,
      '& > *': {
        width: '100% !important',
        paddingLeft: 0,
        paddingRight: 0,
        textAlign: 'center',
      },
    },
  }

  return output
}

export default style
